// import "./services.scss";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import servicecard from "../../../Assets/images/service1.svg";
// import servicecard2 from "../../../Assets/images/service2.svg";
// import servicecard3 from "../../../Assets/images/service3.svg";

// const Services = () => {
//   return (
//     <div className="services-section">
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <div className="service-title">
//               <motion.div
//                 initial={{ opacity: 0, y: 100 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
//                 viewport={{ once: true }}
//               >
//                 <h2>What We Offer</h2>
//               </motion.div>

//               <motion.div
//                 initial={{ opacity: 0, y: 100 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
//                 viewport={{ once: true }}
//               >
//                 <h4>
//                   Take a brief look at <br /> some of the services <br /> we
//                   offer
//                 </h4>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         <div className="row g-4">
//           <div className="col-md-4">
//             <motion.div
//               initial={{ opacity: 0, y: 100 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
//               viewport={{ once: true }}
//             >
//               <div className="service-card h-100">
//                 <div className="service-card-image">
//                   <img src={servicecard} alt="" />
//                 </div>
//                 <div className="service-card-content">
//                   <h2>
//                     Residential
//                     <br />
//                     Structures
//                   </h2>
//                 </div>
//               </div>
//             </motion.div>
//           </div>

//           <div className="col-md-4">
//             <motion.div
//               initial={{ opacity: 0, y: 100 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.99, ease: "easeOut", delay: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <div className="service-card h-100">
//                 <div className="service-card-image">
//                   <img src={servicecard2} alt="" />
//                 </div>
//                 <div className="service-card-content">
//                   <h2>
//                     Public
//                     <br />
//                     Buildings
//                   </h2>
//                 </div>
//               </div>
//             </motion.div>
//           </div>

//           <div className="col-md-4">
//             <motion.div
//               initial={{ opacity: 0, y: 100 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.99, ease: "easeOut", delay: 0.9 }}
//               viewport={{ once: true }}
//             >
//               <div className="service-card h-100">
//                 <div className="service-card-image">
//                   <img src={servicecard3} alt="" />
//                 </div>
//                 <div className="service-card-content">
//                   <h2>
//                     Commercial
//                     <br />
//                     Structures
//                   </h2>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-12">
//             <div className="all-services">
//               <Link to="/services" className="project-btn">
//                 All Services
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   height="15px"
//                   width="15px"
//                   className="project-icon"
//                 >
//                   <path
//                     stroke-linejoin="round"
//                     stroke-linecap="round"
//                     stroke-miterlimit="10"
//                     stroke-width="1.5"
//                     stroke="#292D32"
//                     d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
//                   ></path>
//                 </svg>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Services;

import "./services.scss";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBuilding,
  faCity,
  faMap,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  return (
    <div className="services-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="service-title">
              <motion.div
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h2>What We Offer</h2>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h4>
                  Take a brief look at <br /> some of the services <br /> we
                  offer
                </h4>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="row g-4 justify-content-center service-icons-row">
          <div className="col-md-3 col-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="icon-card"
            >
              <FontAwesomeIcon icon={faHome} className="icon" />
              <h5>Residential Structures</h5>
            </motion.div>
          </div>

          <div className="col-md-3 col-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              className="icon-card"
            >
              <FontAwesomeIcon icon={faBuilding} className="icon" />
              <h5>Public Buildings</h5>
            </motion.div>
          </div>

          <div className="col-md-3 col-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              viewport={{ once: true }}
              className="icon-card"
            >
              <FontAwesomeIcon icon={faCity} className="icon" />
              <h5>Commercial Structures</h5>
            </motion.div>
          </div>

          <div className="col-md-3 col-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              viewport={{ once: true }}
              className="icon-card"
            >
              <FontAwesomeIcon icon={faMap} className="icon" />
              <h5>Urban Planning</h5>
            </motion.div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="all-services">
              <Link to="/services" className="project-btn">
                All Services
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  height="15px"
                  width="15px"
                  className="project-icon"
                >
                  <path
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5"
                    stroke="#292D32"
                    d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
                  ></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
